import { Stack, Text } from '@/components/Chakra'
import { ReactNode } from 'react'

type Props = {
  title: string
  children: ReactNode
}

export const StackTable = ({ title, children }: Props) => {
  return (
    <>
      <Stack py={8} borderBottom={'1px solid'} borderColor={'blackAlpha.100'} direction={['column', 'column', 'row']}>
        <Text width={['auto', 'auto', '30%']} fontWeight={'bold'}>
          {title}
        </Text>
        {children}
      </Stack>
    </>
  )
}
